//Tabs Navigation
const TABS_NAVIGATION = {
    list: 'Список',
    add: 'Добавить',
    add_employee: 'Добавить сотрудника',
    employees: 'Сотрудники',
    company: 'Компания',
    add_user_post_group: 'Добавить группу',
    add_user_post: 'Добавить сообщение',
    levels: 'Уровни',
    users: 'Пользователи',
}

const TITLES = {
    total: 'всего',
    more: 'подробнее',
    not: 'нет',
    show: 'показать',
    go: 'перейти',  
    id: 'id',
    type: 'тип',
    name: 'название', 
}

//Forms
const FORMS_LABELS = {
    name: 'имя',
    description: 'описание',
    email: 'e-mail',
    password: 'пароль',
    user_name: 'имя',
    user_lastname: 'фамилия',
    user_patronymic: 'отчество',
    user_photo: 'фото',
    user_date_of_birth: 'дата рождения',
    user_role: 'роль',
    user_group: 'группа',
    user_status: 'статус',
    by_lastname: 'по фамилии',
    user_exists: 'пользователь есть в системе',
    add_new_user: 'добавить нового пользователя',
    by_email: 'по e-mail',
    enter_user_lastname: 'введите фамилию пользователя',
    enter_user_email: 'введите email пользователя',
    work_place: 'место работы',
    job_title: 'должность',
    enter_event_name: 'введите название события',
    event_name: 'название события',
    list_name: 'название',
    parent_event: 'родительское событие',
    title: 'заголовок',
    subtitle: 'подзаголовок',
    start_date_end_date: 'дата начала и дата окончания',
    start_date: 'дата начала',
    end_date: 'дата окончания',
    add_participants: 'добавить участников',
    date_of_birth: 'дата рождения',
    city: 'город',
    phone: 'телефон',
    text: 'текст',
    grab_files: 'Перетащите или выберите файлы для загрузки',
    attachment: 'прикрепите файлы',
    refer: 'раздел',
    type: 'тип',
    latin_characters: 'название латиницей',
    field_name_translation: 'перевод названия поля',
    block: 'заблокировать',
    fields: 'поля',
    base_url: 'базовый url',
    points_amount: 'количество очков',    
}

//Buttons
const BUTTONS_VALUES = {
    upload: 'загрузить',
    sign_in: 'войти',
    log_out: 'выйти',
    edit: 'редактировать',
    add: 'добавить',
    delete: 'удалить',
    add_root_category: 'добавить корневую категорию',
    add_subcategory: 'добавить подкатегорию',
    save: 'сохранить',
    cancel: 'отмена',
    show_subcategories: 'показать подкатегории',
    hide_subcategories: 'скрыть подкатегории',
    add_employee: 'добавить сотрудника',
    select: 'выбрать',
    add_event: 'добавить событие',
    copy_to_clipboard: 'копировать в буфер обмена',
    add_recipient: 'добавить получателя',
    add_promotion: 'добавить акцию',
    save_promotion: 'сохранить',
    get_sms_balance: 'sms баланс',
    get_sms_status: 'проверить статус sms сообщения',
    send: 'отправить',
    profile_data: 'данные профиля',
    data: 'данные',
}

//Switchers
const SWITCHERS_VALUES = {
    can_delete: 'Удаление разрешено',
    cannot_delete: 'Удаление запрещено',
    blocked: 'Заблокирован',
    active: 'Активен',
    accepted: 'Подтвержден',
    not_accepted: 'Не подтвержден',

}

export {
    TABS_NAVIGATION,
    TITLES,
    FORMS_LABELS,
    BUTTONS_VALUES,
    SWITCHERS_VALUES,
}